import React from 'react';
import authRoles from 'app/auth/authRoles';
import Packages from './Packages';
import PackageEdit from './PackageEdit';

const PackagesConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/Packages',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Packages />
				</React.Suspense>
			),
		},
		{
			path: '/PackageEdit/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<PackageEdit />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.productOwner,
};

export default PackagesConfig;
